import { render, staticRenderFns } from "./BirdSearch.vue?vue&type=template&id=48141b16&scoped=true&"
import script from "./BirdSearch.vue?vue&type=script&lang=js&"
export * from "./BirdSearch.vue?vue&type=script&lang=js&"
import style0 from "./BirdSearch.vue?vue&type=style&index=0&id=48141b16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48141b16",
  null
  
)

export default component.exports